export const statesReleasedForReservations = ['SP', 'RJ', 'ES', 'BA', 'MG'];
